import { ApiService, Form } from '~/shared/api'
import { restGetItem } from '~/shared/utils/decorators'
import { ServiceRestGetItem } from '~/shared/interfaces'
import { AccountVacancyModel } from '~/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { RequestService } from '~/services/RequestService'

interface AccountVacancyService extends ServiceRestGetItem {}

class SaveVacancyForm extends Form {
  constructor(payload: Omit<AccountVacancyModel, 'internship_image'>, image: File | string | null) {
    super()
    Object.assign(this, { vacancy: { ...payload, internship_image: image } })
    this.setSendAs('form-data')
    this.setMethod('POST')
  }
}

@restGetItem
// eslint-disable-next-line no-redeclare
class AccountVacancyService extends ApiService {
  protected route: string = 'vacancy'

  constructor(requestService: RequestService) {
    super(requestService)
  }

  readonly url = '/api/v1/yavagro/vacancies'

  getItemModel(id: number | string): Promise<AccountVacancyModel> {
    return this.getItem(id).then(({ data }) => {
      const raw = isUnknownObject(data) && isUnknownObject(data.data) ? data.data : null
      return new AccountVacancyModel(raw)
    })
  }

  public async saveVacancy(
    payload: Omit<AccountVacancyModel, 'internship_image'>,
    image?: File | string | null
  ): Promise<number | undefined> {
    const form = new SaveVacancyForm(payload, image ?? null)
    const response = await this.requestService.request<{ code?: number; result?: { id?: number } }>({
      url: payload.id ? `${this.url}/${payload.id}` : this.url,
      method: form.getMethod(),
      data: form.serialize()
    })
    return response.data?.result?.id
  }
}

export default AccountVacancyService
